import React from 'react'
import { InlineDisplayContent } from '@ztechapps/webui.input'
import type { FieldProps } from 'formik'

export type FieldEditorProps = {
  name: string
  label?: string
  help?: string
  fieldProps: FieldProps
  component: any
  componentProps?: any
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
}

export const FieldEditor = (props: FieldEditorProps) => {
  const { component, fieldProps, componentProps = {} } = props
  const Component = component

  return (
    <InlineDisplayContent
      label={props.label}
      help={props.help}
      formikField={props.fieldProps}
      value={
        <Component
          {...{
            ...fieldProps.field,
            ...componentProps,
            form: fieldProps.form,
            meta: fieldProps.meta,
            onChange: props.onChange,
            onBlur: props.onBlur,
          }}
        />
      }
    />
  )
}
